import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useState } from 'react';
import { Grid, Box, Flex, Button, IconButton } from '@chakra-ui/react';
import { hasValue, useT } from '@progress-fe/core';
import { Svg } from '../../../../base';
import { JsFieldName } from '../../../../jsFormBase';
import { Input, InputNumber, Select } from '../../../../inputs';
import { CompressorCurveTable } from './components';
const getOptionLabel = (options, value) => {
    if (!hasValue(value)) {
        return '';
    }
    return options.find((item) => item.value === value)?.label ?? '';
};
const CompressorCurveFC = ({ isReadonly, fieldConfig, curve, errors, onChange, onDelete }) => {
    const { t } = useT();
    const [flowTitle, setFlowTitle] = useState('');
    const [pressureTitle, setPressureTitle] = useState('');
    useEffect(() => {
        const title = hasValue(curve.flowType)
            ? getOptionLabel(fieldConfig.flowTypeOptions, curve.flowType)
            : '';
        setFlowTitle(title);
    }, [curve.flowType, fieldConfig.flowTypeOptions]);
    useEffect(() => {
        const title = hasValue(curve.pressureType)
            ? getOptionLabel(fieldConfig.pressureTypeOptions, curve.pressureType)
            : '';
        setPressureTitle(title);
    }, [curve.pressureType, fieldConfig.pressureTypeOptions]);
    const handleChangeCurve = (value) => {
        onChange({
            ...curve,
            ...value
        });
    };
    const handleDeleteValue = (index) => {
        const newValues = [...curve.values];
        newValues.splice(index, 1);
        handleChangeCurve({ values: newValues });
    };
    const handleAddItem = () => {
        const newValues = [...curve.values];
        newValues.push({
            efficiency: '',
            flow: '',
            pressure: ''
        });
        handleChangeCurve({ values: newValues });
    };
    return (_jsxs(Flex, { flexDirection: "column", gap: "8px", children: [_jsxs(Grid, { gap: "4px", p: "2px 0", templateColumns: "1fr 2fr", children: [_jsx(JsFieldName, { name: t('jsfields.CompressorCurve.name') }), _jsxs(Flex, { gap: "4px", children: [_jsx(Input, { size: "xs", variant: "outline", isOnChangeOnlyOnBlur: true, value: curve.name, disabled: isReadonly, isInvalid: errors?.isNameInvalid, onChange: (value) => handleChangeCurve({ name: value }) }), _jsx(IconButton, { size: "smSquare", "aria-label": "", variant: "ghost", flexShrink: "0", isDisabled: isReadonly, icon: _jsx(Svg, { size: "s12", name: "Cross" }), onClick: onDelete })] }), _jsx(JsFieldName, { name: t('jsfields.CompressorCurve.flowType') }), _jsx(Select, { name: "model", options: fieldConfig.flowTypeOptions, isDisabled: isReadonly, placeholder: t('common.notSelected'), value: fieldConfig.flowTypeOptions.find((opt) => opt.value === curve.flowType), onChange: (selected) => {
                            handleChangeCurve({ flowType: selected.value });
                        } }), _jsx(JsFieldName, { name: t('jsfields.CompressorCurve.pressureType') }), _jsx(Select, { name: "model", options: fieldConfig.pressureTypeOptions, isDisabled: isReadonly, placeholder: t('common.notSelected'), value: fieldConfig.pressureTypeOptions.find((opt) => opt.value === curve.pressureType), onChange: (selected) => {
                            handleChangeCurve({
                                pressureType: selected.value
                            });
                        } }), _jsx(JsFieldName, { name: t('jsfields.CompressorCurve.rotationSpeed') }), _jsx(InputNumber, { size: "xs", variant: "outline", value: curve.rotationSpeed, rightElement: "\u043E\u0431.\u043C\u0438\u043D", disabled: isReadonly, isOnChangeOnlyOnBlur: true, onChange: (value) => {
                            if (!value) {
                                return;
                            }
                            handleChangeCurve({ rotationSpeed: value });
                        } })] }), !!curve.values.length && (_jsx(Box, { w: "100%", borderRadius: "4px", border: "1px", borderColor: "border", p: "2px", children: _jsx(CompressorCurveTable, { isReadonly: isReadonly, values: curve.values, flowTitle: flowTitle, pressureTitle: pressureTitle, onDeleteItem: handleDeleteValue, onValuesChanged: (values) => handleChangeCurve({ values }) }) })), !isReadonly && (_jsx(Button, { variant: "ghost", size: "smSquare", width: "100%", onClick: handleAddItem, children: t('jsfields.CompressorCurve.addPoint') }))] }));
};
export const CompressorCurve = memo(CompressorCurveFC);
//# sourceMappingURL=CompressorCurve.js.map